import { useMutation, useQueryClient } from "@tanstack/react-query";
import { dynamicNotification } from "src/utils/Notifications";
import __ from "src/utils/Translations";
import { EmployeeFormValues } from "src/Pages/Company/EmployeeManagement/CompanyEmployees/Edit/EmployeeEmployment/types/employeeTypes";
import { saveEmploymentData } from "src/Pages/Company/EmployeeManagement/CompanyEmployees/Edit/EmployeeEmployment/api/api";

export const useSaveEmploymentData = (
  companyId: string,
  employeeId: string
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (formData: EmployeeFormValues) =>
      saveEmploymentData(companyId, employeeId, formData),
    onSuccess: () => {
      dynamicNotification(__("Dane zostały zaktualizowane"), "success");
      queryClient.invalidateQueries({
        queryKey: ["employment-data"],
      });
    },
    onError: () => {
      dynamicNotification(__("Błąd aktualizacji danych"), "error");
    },
  });
};
